import { useEffect, useState } from "react";

/**
 * True on touch/mobile devices, where the camera "Take photo" capture flow is
 * meaningful. Desktops (mouse, no camera-capture affordance) get only the file
 * picker. Uses the `(pointer: coarse)` media query — the standard signal for a
 * primary touch pointer — and tracks changes (e.g. a 2-in-1 switching modes).
 */
export function useIsTouchDevice(): boolean {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    if (!window.matchMedia) return;
    const mediaQuery = window.matchMedia("(pointer: coarse)");
    const update = () => setIsTouch(mediaQuery.matches);
    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  return isTouch;
}
